<template>
  <div>
    <!-- 电池仓 -->
    <div class="batteryBox">
      <div
        class="margin-top-sm flex flex-direction justify-center align-center battery"
        :class="{'battery-100':item.status==3,'battery-grey':item.status==1||item.status==5,'battery-red':!item.temperature||item.status*1===0||item.status*1===4}"
        v-for="(item, index) in batteryHolder"
        :key="index"
        @click="jumpToBatteryHolder(item)"
      >
        <div class="flex justify-center align-center">
          <div v-show="item.status*1===2||!item.temperature" class="batteryIcon" :class="{'red':!item.temperature}"></div>
          <div v-show="item.status*1===1" class="batteryIcon grey"></div>
          <div v-show="item.status*1===5" class="batteryIcon error"></div>
          <div class="text-xss batteryNum">
            {{item.currentSoc}}<span class="text-10">%</span>
          </div>
        </div>
        <div class="text-10">
          NO.{{item.positionNo}}<span v-show="!item.temperature">(温度告警)</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data() {
    return {
      batteryHolder:[]
    };
  },
  components: {},
  props: {},
  watch: {},
  mounted() {
    setInterval(() => {
      this.getData( {stationId: this.$route.query.stationId});
    }, 10*1000);
  },
  methods: {
    getData(data) {
      this.selectStationBatteryHolder(data);
    },
    selectStationBatteryHolder(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'chongdiancang-TiDB',
          '@station_id':data.stationId,
        })
        .then((res) => {
          if(!res) return;
          _this.batteryHolder = res.map(item =>{
            return {
              ...item,
              temperature:item.temperature>60?false:true
            }
          })
          sessionStorage.setItem('batteryId',_this.batteryHolder[0].batteryId);
          sessionStorage.setItem('chargingWarehouseNumber',_this.batteryHolder[0].chargingWarehouseNumber);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转到电池仓页面
    jumpToBatteryHolder(i){
      //query-路由传参
      // batteryHolder?stationId=29cf1372-5bc1-4127-9a51-e260f3749ad3&batteryId=1000290070
      let routeName = '/batteryHolder';
      if(window.location.href.indexOf("pc")){
        routeName = '/pcbatteryHolder';
      }
      this.$router.push({
          path: routeName,
          query: {
            stationId: this.$route.query.stationId,
            batteryId: i.batteryId,
            chargingWarehouseNumber: i.chargingWarehouseNumber,
          }
      })
      
    }
  },
};
</script>
<style lang="scss" scoped>
.batteryBox {
  display: grid;
  grid-template-columns: repeat(7, 150px);
  grid-template-rows: repeat(4, 46px);
  grid-row-gap: 16px;
  grid-column-gap: 30px;
  max-height:200px;
  overflow-y: scroll;
  flex-wrap: wrap;
}
.battery {
  width: 150px;
  height: 46px;
  background: url('../../assets/images/site/battery_green_light.png') no-repeat;
  background-size: 150px 46px;
}
.battery-100 {
  background: url('../../assets/images/site/battery_green.png') no-repeat;
  background-size: 150px 46px;
}
.battery-red {
  background: url('../../assets/images/site/battery_red.png') no-repeat;
  background-size: 150px 46px;
}
.battery-grey {
  background: url('~@/assets/images/site/battery_grey.png') no-repeat;
  background-size: 140px 46px;
}
.batteryIcon {
  width: 12px;
  height: 16px;
  background: url('../../assets/images/site/light-blue.png') no-repeat;
  background-size: 12px 16px;
  &.red{
    background: url('../../assets/images/site/light-red.png') no-repeat;
    background-size: 12px 16px;
  }
  &.grey{
    background: url('../../assets/images/site/light-white.png') no-repeat;
    background-size: 12px 16px;
  }
  &.error{
    background: url('../../assets/images/site/light-error.png') no-repeat;
    background-size: 12px 16px;
  }
}
.batteryNum {
  line-height: 10px;
}
</style>
